import React from 'react';
import { Button } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';
import { useAsyncState } from '@/utils/hooks';
import { ExportColumnDefinition, getSimpleOrderExportColumns, SimpleOrderExportOptions } from '@/services/order-export';
import { ExportColumnSelection } from './ExportColumnSelection';

export interface SimpleExportConfigurationProps {
    value: SimpleOrderExportOptions;
    onChange(newValue: SimpleOrderExportOptions): void;
}

function getDefaultOptions(columns: ExportColumnDefinition[] | null): SimpleOrderExportOptions {
    return {
        columns: columns ? columns.filter((x) => x.isDefault).map((x) => x.key) : [],
    };
}

export const SimpleExportConfiguration: React.FC<SimpleExportConfigurationProps> = ({ value, onChange }) => {
    const [columns] = useAsyncState(() => getSimpleOrderExportColumns(), [], null);
    const fixedValue: SimpleOrderExportOptions = {
        ...getDefaultOptions(columns),
        ...value,
    };

    const handleChange = (changes: Partial<SimpleOrderExportOptions>) => {
        onChange({ ...fixedValue, ...changes });
    };

    const resetToDefaults = () => {
        onChange(getDefaultOptions(columns));
    };

    if (!columns) {
        return null;
    }

    return (
        <div>
            <ExportColumnSelection
                value={fixedValue.columns}
                onChange={(newValue) => handleChange({ columns: newValue })}
                columns={columns}
            />

            <Button variant="primary" onClick={resetToDefaults}>
                <Trans>Reset to default</Trans>
            </Button>
        </div>
    );
};
